module.exports = __webpack_public_path__ + "img/header-noti-new.d1db0e24.svg";